import { render, staticRenderFns } from "./QuestionAnalysisMobile.vue?vue&type=template&id=c4465f12&scoped=true"
import script from "./QuestionAnalysisMobile.vue?vue&type=script&lang=js"
export * from "./QuestionAnalysisMobile.vue?vue&type=script&lang=js"
import style0 from "./QuestionAnalysisMobile.vue?vue&type=style&index=0&id=c4465f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4465f12",
  null
  
)

export default component.exports